export default "__VITE_ASSET__jhSlbgc$__"